import React from 'react';
import CampaignVisSettings, {
    CampaignVisualisationSettingsProvider
} from 'campaignvis/CampaignVisSettings';
import MapBackground from 'campaignvis/CampaignVisMapBackground';
import SummaryStatistics from 'components/SummaryStatistics';
import ExportScreenList from 'components/ExportScreenList';
import HeaderMenu from '../layout/HeaderMenu';
import SampledAvails from '../routes/SampledAvails';
import ForecastingRunner from '../components/forecasting-panel/ForecastingRunner';

export default function HexbinTowers() {
    return (
        <div className="relative h-full">
                <CampaignVisualisationSettingsProvider>
                    <MapBackground />
                    {/*<CampaignVisSettings/>*/}
                </CampaignVisualisationSettingsProvider>
        </div>
    );
}